import styles from './ArticleDate.module.scss';
import { formatDate } from '../../../../../helpers/date';
import classNames from 'classnames';

export interface ArticleDateProps {
	date: string;
	spacing?: 'Small' | 'Medium' | null;
}

export const UI_ArticleDate = ({ date, spacing }: ArticleDateProps) => (
	<p className={classNames(styles.ArticleDate, { [styles.ArticleDate__spacing_small]: spacing === 'Small' })}>
		{formatDate(new Date(date), 'dd.mm.yyyy')}
	</p>
);
